module.exports = __webpack_public_path__ + "static/media/logo.7fd7d606.png";